export function isFalsy(value: unknown) {
  return !value;
}
